class SpotlightNav {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        const title = this._elem.querySelector('[data-spotlight-nav-title]')
        if (title) {
            title.addEventListener('click', () => {
                this._elem.classList.toggle('active')
            })
        }
    }
}

export default SpotlightNav



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SpotlightNav.js